(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-mh-product-root]').forEach((root) => {
      if (root.dataset.mhInitialized === 'true') return;
      root.dataset.mhInitialized = 'true';

      const variantData = root.querySelector('[data-mh-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent) : [];
      const optionSelectors = Array.from(root.querySelectorAll('[data-mh-option-index]'));
      const variantInput = root.querySelector('[data-mh-variant-id]');
      const productForm = root.querySelector('.mh-pdp__form');
      const price = root.querySelector('[data-mh-price]');
      const compare = root.querySelector('[data-mh-compare]');
      const addButton = root.querySelector('[data-mh-add]');
      const addLabel = root.querySelector('[data-mh-add-label]');
      const addStatus = root.querySelector('[data-mh-add-status]');
      const variantTitle = root.querySelector('[data-mh-variant-title]');
      const sku = root.querySelector('[data-mh-sku]');
      const skuRow = root.querySelector('[data-mh-sku-row]');
      const quantity = root.querySelector('[data-mh-quantity]');
      const sizeGuide = root.querySelector('[data-mh-size-guide]');
      const sizeGuideOpen = root.querySelector('[data-mh-size-guide-open]');
      const sizeGuideClose = root.querySelector('[data-mh-size-guide-close]');

      const showMedia = (mediaId) => {
        if (!mediaId) return;
        root.querySelectorAll('[data-mh-media-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.mhMediaPanel !== String(mediaId);
        });
        root.querySelectorAll('[data-mh-media-target]').forEach((button) => {
          button.setAttribute('aria-current', String(button.dataset.mhMediaTarget === String(mediaId)));
        });
      };

      root.querySelectorAll('[data-mh-media-target]').forEach((button) => {
        button.addEventListener('click', () => showMedia(button.dataset.mhMediaTarget));
      });

      const updateVariant = () => {
        const chosen = optionSelectors.map((select) => select.value);
        const variant = variants.find((candidate) => candidate.options.every((value, index) => value === chosen[index]));
        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (addLabel) addLabel.textContent = addButton.dataset.labelUnavailable;
          return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (price) price.textContent = variant.price;
        if (compare) {
          compare.hidden = !variant.compareAtPrice;
          compare.textContent = variant.compareAtPrice || '';
        }
        if (addButton) addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? addButton.dataset.labelAvailable : addButton.dataset.labelSoldOut;
        if (variantTitle) variantTitle.textContent = variant.title;
        if (skuRow) skuRow.hidden = !variant.sku;
        if (sku) sku.textContent = variant.sku || '';
        showMedia(variant.featuredMediaId);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      optionSelectors.forEach((select) => select.addEventListener('change', updateVariant));

      root.querySelectorAll('[data-mh-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!quantity) return;
          const direction = button.dataset.mhQuantityChange === 'up' ? 1 : -1;
          const current = Number(quantity.value) || 1;
          quantity.value = String(Math.min(10, Math.max(1, current + direction)));
        });
      });

      if (productForm && addButton) {
        productForm.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (addButton.disabled || addButton.dataset.mhLoading === 'true') return;

          const defaultLabel = addButton.dataset.labelAvailable || 'Add to cart';
          addButton.dataset.mhLoading = 'true';
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Adding…';
          if (addStatus) addStatus.textContent = '';

          try {
            const formData = new FormData(productForm);
            const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
              .map((component) => component.dataset.sectionId)
              .filter((sectionId, index, allIds) => sectionId && allIds.indexOf(sectionId) === index);

            if (sectionIds.length > 0) {
              formData.set('sections', sectionIds.join(','));
              formData.set('sections_url', window.location.pathname);
            }

            const rootPath = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${rootPath}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: formData,
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item.');

            const cartResponse = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
            const cart = cartResponse.ok ? await cartResponse.json() : undefined;
            const itemCount = Number(formData.get('quantity')) || 1;

            productForm.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: productForm.id,
                data: {
                  source: 'mh-product-form',
                  itemCount,
                  variantId: String(formData.get('id') || ''),
                  sections: result.sections || {},
                },
              },
            }));

            const cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
            if (quantity) quantity.value = '1';
            if (addLabel) addLabel.textContent = 'Added';
            if (addStatus) addStatus.textContent = 'Added to your cart.';
          } catch (error) {
            const message = error instanceof Error ? error.message : 'We could not add this item. Please try again.';
            if (addStatus) addStatus.textContent = message;
            if (addLabel) addLabel.textContent = defaultLabel;
          } finally {
            window.setTimeout(() => {
              addButton.removeAttribute('data-mh-loading');
              addButton.disabled = false;
              if (addLabel) addLabel.textContent = defaultLabel;
            }, 900);
          }
        });
      }

      if (sizeGuide && sizeGuideOpen && sizeGuideClose) {
        sizeGuideOpen.addEventListener('click', () => sizeGuide.showModal());
        sizeGuideClose.addEventListener('click', () => sizeGuide.close());
        sizeGuide.addEventListener('click', (event) => {
          if (event.target === sizeGuide) sizeGuide.close();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
